<template>
  <div
    class="sidearm-ad ad"
    v-if="
      (campaigns && campaigns.length) || (location && location.type === 'dfp')
    "
  >
    <component
      v-if="location && location.type"
      :is="location.type"
      :name="name"
      :location="location"
      :campaigns="campaigns"
      @set_width="emit_width"
    />
  </div>
</template>

<script>
import { get } from "@/helpers";
import SingleAd from "./SingleAd.vue";
import DfpAd from "./DfpAd.vue";

export default {
  props: {
    name: {
      type: String,
      required: true,
      default: ""
    },
    sportId: {
      type: Number,
      required: true
    }
  },

  components: {
    single: SingleAd,
    dfp: DfpAd
  },

  data: () => ({
    location: null,
    campaigns: []
  }),

  methods: {
    emit_width(value) {
      this.$emit("set_width", value);
    },
    get_campaigns() {
      let request_options = {
        type: "ads",
        sport_id: this.sportId,
        name: this.name
      };

      get("/services/adaptive_components.ashx", request_options).then(ad => {
        this.location = ad.location;
        this.campaigns = ad.campaigns;
      });
    }
  },
  created() {
    this.get_campaigns();
  }
};
</script>
